import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Card,
  Descriptions,
  Table,
  Select,
  Tag,
  Image,
  Button,
  message,
  Divider,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import api from "../../api";

const statusOptions = {
  payment: {
    pending: { label: "در انتظار پرداخت", color: "gold" },
    paid: { label: "پرداخت شده", color: "green" },
    failed: { label: "ناموفق", color: "red" },
    refunded: { label: "مسترد شده", color: "blue" },
    canceled: { label: "لغو شده", color: "volcano" },
  },
  delivery: {
    pending: { label: "در انتظار پردازش", color: "gold" },
    processing: { label: "در حال پردازش", color: "blue" },
    shipped: { label: "ارسال شده", color: "cyan" },
    delivered: { label: "تحویل داده شده", color: "green" },
    canceled: { label: "لغو شده", color: "volcano" },
    returned: { label: "مرجوع شده", color: "red" },
  },
};

const OrderDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [trackingCode, setTrackingCode] = useState("");

 
  

  useEffect(() => {
    fetchOrderDetails();
  }, [id]);

  useEffect(() => {
    if (order) {
      setTrackingCode(order.tracking_code || "");
    }
  }, [order]);

  const fetchOrderDetails = async () => {
    try {
      const response = await api.get(`/panel/order/${id}`);
      setOrder(response.data.data);
    } catch (error) {
      message.error("خطا در دریافت جزئیات سفارش");
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (field, value) => {
    setUpdating(true);
    try {
      await api.post(`/panel/order/${id}?_method=PUT`, { [field]: value });
      setOrder({ ...order, [field]: value });
      message.success("وضعیت سفارش با موفقیت بروزرسانی شد");
    } catch (error) {
      message.error("خطا در تغییر وضعیت سفارش");
    } finally {
      setUpdating(false);
    }
  };

  const handleTrackingCodeSubmit = async () => {
    setUpdating(true);
    try {
      await api.post(`/panel/order/${id}?_method=PUT`, {
        tracking_code: trackingCode,
      });
      message.success("کد رهگیری با موفقیت ثبت شد");
      setOrder({ ...order, tracking_code: trackingCode });
    } catch (error) {
      message.error("خطا در ثبت کد رهگیری");
    } finally {
      setUpdating(false);
    }
  };

  // const itemsTotalPrice = order.items.reduce(
  //   (sum, item) => sum + Number(item.price) * Number(item.count),
  //   0
  // );


  const columns = [
    {
      title: "محصول",
      dataIndex: "post",
      key: "product",
      render: (post) => (
        <div className="flex items-center space-x-4">
          <Image
            src={post.image}
            alt={post.title}
            width={80}
            className="rounded-md"
          />
          <div>
            <div className="font-medium">{post.title}</div>
            <div className="text-gray-500 text-sm">
              کد فنی: {post.technical_code}
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "برند",
      dataIndex: "brand",
      key: "brand",
      render: (brand) => brand?.name || "—",
    },
    {
      title: "فروشنده",
      dataIndex: "seller",
      key: "seller",
      render: (seller) => seller?.name || "—",
    },
    {
      title: "گارانتی",
      dataIndex: "guarantee",
      key: "guarantee",
      render: (guarantee) => guarantee || "—",
    },
    {
      title: "قیمت",
      dataIndex: "price",
      key: "price",
      render: (price) => <span>{Number(price).toLocaleString()} تومان</span>,
    },
    {
      title: "تعداد",
      dataIndex: "count",
      key: "quantity",
    },
    {
      title: "مجموع",
      key: "total",
      render: (_, item) => (
        <span className="font-medium">
          {(Number(item.price) * Number(item.count)).toLocaleString()} تومان
        </span>
      ),
    },
  ];

  if (loading) return <div>در حال بارگذاری...</div>;
  if (!order) return <div>سفارش پیدا نشد</div>;

  return (
    <div>
      <Card className="mb-6">
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate("/orders")}
          className="mb-4"
        >
          بازگشت به سفارش‌ها
        </Button>
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-semibold">سفارش #{order.id}</h1>
        </div>

        <Descriptions bordered column={2}>
          <Descriptions.Item label="نام مشتری">
            {order.user.name}
          </Descriptions.Item>
          <Descriptions.Item label="ایمیل">
            {order.user.email || "ندارد"}
          </Descriptions.Item>
          <Descriptions.Item label="تلفن">
            {order.user.number || "ندارد"}
          </Descriptions.Item>
          <Descriptions.Item label="درگاه پرداخت">
            {order?.payment_gate || "ندارد"}
          </Descriptions.Item>
          <Descriptions.Item label="تاریخ سفارش">
            {order.created_at}
          </Descriptions.Item>
          <Descriptions.Item label="کد پیگیری">
            {order.tracking_code || "ندارد"}
          </Descriptions.Item>

          {/* وضعیت پرداخت */}
          <Descriptions.Item label="وضعیت پرداخت">
            <Tag
              color={statusOptions.payment[order.payment_status]?.color}
              className="mr-2"
            >
              {statusOptions.payment[order.payment_status]?.label}
            </Tag>
          </Descriptions.Item>

          {/* وضعیت تحویل */}
          <Descriptions.Item label="وضعیت تحویل">
            <div>
              <Tag
                color={statusOptions.delivery[order.deliver_status]?.color}
                className="mr-2"
              >
                {statusOptions.delivery[order.deliver_status]?.label}
              </Tag>
              <Select
                value={order.deliver_status}
                onChange={(value) =>
                  handleStatusChange("deliver_status", value)
                }
                options={Object.entries(statusOptions.delivery).map(
                  ([value, { label }]) => ({ value, label })
                )}
                disabled={updating}
                style={{ width: 160, marginTop: 8 }}
              />
              {/* فقط وقتی ارسال شده انتخاب شود */}
              {order.deliver_status === "shipped" && (
                <div className="mt-4 flex items-center gap-2">
                  <input
                    type="text"
                    className="border px-2 py-1 rounded w-64"
                    placeholder="کد رهگیری را وارد کنید"
                    value={trackingCode}
                    onChange={(e) => setTrackingCode(e.target.value)}
                  />
                  <Button
                    type="primary"
                    onClick={handleTrackingCodeSubmit}
                    loading={updating}
                  >
                    ثبت کد رهگیری
                  </Button>
                </div>
              )}
            </div>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="جزئیات قیمت سفارش" className="mb-6">
        <Descriptions bordered column={1}>
          <Descriptions.Item label="قیمت کل">
            {Number(order.price).toLocaleString()} تومان
          </Descriptions.Item>
          <Descriptions.Item label="هزینه ارسال">
            {Number(order.shipping_price).toLocaleString()} تومان
          </Descriptions.Item>
          <Descriptions.Item label="مالیات">
            {Number(order.tax_price).toLocaleString()} تومان
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="اقلام سفارش">
        <Table
          columns={columns}
          dataSource={order.items}
          rowKey="id"
          pagination={false}
        />
        <Divider />
        <div className="flex justify-end">
          <div className="text-xl font-medium">
            {/* مجموع قیمت محصولات: {Number(itemsTotalPrice).toLocaleString()} تومان */}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default OrderDetail;
